import React from 'react';
import PageHeader from '@iso/components/utility/pageHeader';
import IntlMessages from '@iso/components/utility/intlMessages';
import MonthlyOverview from '../../components/MonthlyOverview/MonthlyOverview';
import Notifications from '../../components/Notifications/Notifications';

export default function Dashboard() {
  return (
    <div>
      <PageHeader>
        <IntlMessages id="page.overview.title" />
        <span>
          <IntlMessages id="page.overview.subtitle" />
        </span>
      </PageHeader>
      <div className="grid grid-cols-1 gap-y-10">
        <div className="p-5 rounded-xl bg-white w-full shadow-sm">
          <h2 className="text-xl mb-10">
            <IntlMessages id="page.dashboard.graph.title" />
          </h2>
          <div className="items-center justify-center">
            <MonthlyOverview />
          </div>
        </div>
        <Notifications />
      </div>
    </div>
  );
}
